import { WatchOverviewAttributes, WatchSpecificationAttributes, WatchPurchaseAttributes } from './watchDataAttributes';
import { CarOverviewAttributes, CarSpecificationAttributes, CarPurchaseAttributes } from './carDataAttributes';
import { ComicOverviewAttributes, ComicSpecificationAttributes, ComicPurchaseAttributes } from './comicDataAttributes';
import { OtherOverviewAttributes, OtherSpecificationAttributes, OtherPurchaseAttributes } from './otherDataAttributes';
import { ArtOverviewAttributes, ArtSpecificationAttributes, ArtPurchaseAttributes } from './artDataAttributes';
import { AntiqueOverviewAttributes, AntiqueSpecificationAttributes, AntiquePurchaseAttributes } from './antiqueDataAttributes';
import { BookOverviewAttributes, BookSpecificationAttributes, BookPurchaseAttributes } from './bookDataAttributes';
import { CoinOverviewAttributes, CoinSpecificationAttributes, CoinPurchaseAttributes } from './coinDataAttributes';
import { StampOverviewAttributes, StampSpecificationAttributes, StampPurchaseAttributes } from './stampDataAttributes';
import { CameraOverviewAttributes, CameraSpecificationAttributes, CameraPurchaseAttributes } from './cameraDataAttributes';
import { FirearmOverviewAttributes, FirearmSpecificationAttributes, FirearmPurchaseAttributes } from './firearmDataAttributes';
import { HandbagOverviewAttributes, HandbagSpecificationAttributes, HandbagPurchaseAttributes } from './handbagDataAttributes';
import { JewelryOverviewAttributes, JewelrySpecificationAttributes, JewelryPurchaseAttributes } from './jewelryDataAttributes';
import { ToyOverviewAttributes, ToySpecificationAttributes, ToyPurchaseAttributes } from './toyDataAttributes';
import { HistoricalMemOverviewAttributes, HistoricalMemSpecificationAttributes, HistoricalMemPurchaseAttributes } from './historicalMemorabiliaDataAttributes';
import { MovieMemOverviewAttributes, MovieMemSpecificationAttributes, MovieMemPurchaseAttributes } from './movieMemorabiliaDataAttributes';
import { MusicalInstrumentOverviewAttributes, MusicalInstrumentSpecificationAttributes, MusicalInstrumentPurchaseAttributes } from './musicalInstrumentDataAttributes';
import { MusicMemOverviewAttributes, MusicMemSpecificationAttributes, MusicMemPurchaseAttributes } from './musicMemorabiliaDataAttributes';
import { SportsMemOverviewAttributes, SportsMemSpecificationAttributes, SportsMemPurchaseAttributes } from './sportsMemorabiliaDataAttributes';
import { WineOverviewAttributes, WineSpecificationAttributes, WinePurchaseAttributes } from './wineDataAttributes';
import { SportsCardOverviewAttributes, SportsCardSpecificationAttributes, SportsCardPurchaseAttributes } from './sportsCardDataAttributes';
import { VinylRecordOverviewAttributes, VinylRecordSpecificationAttributes, VinylRecordPurchaseAttributes } from './vinylRecordDataAttributes';

export default {

  overview: {
    WATCH: WatchOverviewAttributes,
    CAR: CarOverviewAttributes,
    COMIC: ComicOverviewAttributes,
    OTHER: OtherOverviewAttributes,
    ART: ArtOverviewAttributes,
    ANTIQUE: AntiqueOverviewAttributes,
    BOOK: BookOverviewAttributes,
    COIN: CoinOverviewAttributes,
    STAMP: StampOverviewAttributes,
    CAMERA: CameraOverviewAttributes,
    FIREARM: FirearmOverviewAttributes,
    HANDBAG: HandbagOverviewAttributes,
    JEWELRY: JewelryOverviewAttributes,
    TOY: ToyOverviewAttributes,
    MUSICAL_MEM: MusicMemOverviewAttributes,
    SPORTS_MEM: SportsMemOverviewAttributes,
    HISTORIC_MEM: HistoricalMemOverviewAttributes,
    MOVIE_MEM: MovieMemOverviewAttributes,
    MUSICAL_INST: MusicalInstrumentOverviewAttributes,
    WINE: WineOverviewAttributes,
    SPORTS_CARD: SportsCardOverviewAttributes,
    VINYL_RECORD: VinylRecordOverviewAttributes,
  },

  specifications: {
    WATCH: WatchSpecificationAttributes,
    CAR: CarSpecificationAttributes,
    OTHER: OtherSpecificationAttributes,
    COMIC: ComicSpecificationAttributes,
    ART: ArtSpecificationAttributes,
    ANTIQUE: AntiqueSpecificationAttributes,
    BOOK: BookSpecificationAttributes,
    COIN: CoinSpecificationAttributes,
    STAMP: StampSpecificationAttributes,
    CAMERA: CameraSpecificationAttributes,
    FIREARM: FirearmSpecificationAttributes,
    HANDBAG: HandbagSpecificationAttributes,
    JEWELRY: JewelrySpecificationAttributes,
    TOY: ToySpecificationAttributes,
    MUSICAL_MEM: MusicMemSpecificationAttributes,
    SPORTS_MEM: SportsMemSpecificationAttributes,
    HISTORIC_MEM: HistoricalMemSpecificationAttributes,
    MOVIE_MEM: MovieMemSpecificationAttributes,
    MUSICAL_INST: MusicalInstrumentSpecificationAttributes,
    WINE: WineSpecificationAttributes,
    SPORTS_CARD: SportsCardSpecificationAttributes,
    VINYL_RECORD: VinylRecordSpecificationAttributes,
  },

  purchase_information: {
    WATCH: WatchPurchaseAttributes,
    CAR: CarPurchaseAttributes,
    OTHER: OtherPurchaseAttributes,
    COMIC: ComicPurchaseAttributes,
    COIN: CoinPurchaseAttributes,
    STAMP: StampPurchaseAttributes,
    ART: ArtPurchaseAttributes,
    ANTIQUE: AntiquePurchaseAttributes,
    BOOK: BookPurchaseAttributes,
    CAMERA: CameraPurchaseAttributes,
    FIREARM: FirearmPurchaseAttributes,
    HANDBAG: HandbagPurchaseAttributes,
    JEWELRY: JewelryPurchaseAttributes,
    TOY: ToyPurchaseAttributes,
    MUSICAL_MEM: MusicMemPurchaseAttributes,
    SPORTS_MEM: SportsMemPurchaseAttributes,
    HISTORIC_MEM: HistoricalMemPurchaseAttributes,
    MOVIE_MEM: MovieMemPurchaseAttributes,
    MUSICAL_INST: MusicalInstrumentPurchaseAttributes,
    WINE: WinePurchaseAttributes,
    SPORTS_CARD: SportsCardPurchaseAttributes,
    VINYL_RECORD: VinylRecordPurchaseAttributes,
  },

};



// WEBPACK FOOTER //
// ./src/config/overview.js